import type { LogoMarqueeItem } from "@/components/ui/LogoMarquee";

const SCRIPTARIO_BRAND_LOGOS: LogoMarqueeItem[] = [
  { src: "/assets/brand-logos/scriptario-mono/notion.svg", alt: "Notion", width: 128 },
  { src: "/assets/brand-logos/scriptario-mono/miro.png", alt: "Miro", width: 112 },
  { src: "/assets/brand-logos/scriptario-mono/airtable.svg", alt: "Airtable", width: 164 },
  { src: "/assets/brand-logos/scriptario-mono/asana.svg", alt: "Asana", width: 172 },
  { src: "/assets/brand-logos/scriptario-mono/trello.svg", alt: "Trello", width: 126 },
  { src: "/assets/brand-logos/scriptario-mono/canva.svg", alt: "Canva", width: 112 },
  { src: "/assets/brand-logos/scriptario-mono/typeform.svg", alt: "Typeform", width: 190 },
  { src: "/assets/brand-logos/scriptario-mono/danone.svg", alt: "Danone", width: 136 },
  { src: "/assets/brand-logos/scriptario-mono/dropbox.svg", alt: "Dropbox", width: 172 },
  { src: "/assets/brand-logos/scriptario-mono/calendly.svg", alt: "Calendly", width: 174 },
];

export function getHeroBrandLogos(): LogoMarqueeItem[] {
  return SCRIPTARIO_BRAND_LOGOS;
}
